module.exports = __webpack_public_path__ + "img/client.5f4e1dac.png";